<div class="grid gap-4" style="margin-top: 50px;">
    <div class="col-12">
        <div class="logo-wizard">
            <div class="flex align-items-center justify-content-center" style="margin-top: 1rem; margin-bottom: 1rem">
                <img [src]="_globals.whiteLabel.logo" alt="logo" width="150px" />
            </div>
        </div>
    </div>
    <!-- <div class="conn-card col-3">
        <div class="grid" *ngFor="let item of mitems">
            <div class="col-fixed my-3" style="width:60px;">
                <div class="flex justify-content-start flex-wrap card-container blue-container">
                    <div class="flex align-items-center justify-content-center w-3rem h-3rem n-setup-number"
                        [ngClass]="item.id==currentStep?'biz-setup-number-active':'n-setup-number'">
                        <span *ngIf="!item.actionSaved">{{item.id}}</span>
                        <span *ngIf="item.actionSaved">
                            <i class="pi pi-check"
                                style="font-size: 1.2em; font-weight: 700;"></i></span>
                    </div>
                </div>
            </div>
            <div class="col my-3">
                <p [ngClass]="item.id==currentStep ? 'biz-setup-menu-header-active':'biz-setup-menu-header'"><span
                        [ngClass]="item.id==currentStep?'wizard-title-active':'wizard-title'">{{item.title}}</span></p>
                <p class="biz-setup-menu-detail text-muted">{{item.desc}}</p>
            </div>
        </div>
    </div> -->
    <!-- <div class="grid">
            <div class="col-3 align-self-center">
                <span id="biz-setup-number">1</span>
            </div>
            <div class="col-8 my-4">
                <h3 class="fw-bolder d-flex align-items-center text-dark mx-2">
                    General Info
                    <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        ngbTooltip="Billing is issued based on your selected account type"
                    ></i>
                </h3>

                <div class="text-gray-400 fw-bold fs-6 mx-2">
                    Set some generic info about your business
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-3 align-self-center">
                <span id="biz-setup-number">2</span>
            </div>
            <div class="col-8 my-4">
                <h3 class="fw-bolder d-flex align-items-center text-dark mx-2">
                    Location Setup
                    <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        ngbTooltip="Billing is issued based on your selected account type"
                    ></i>
                </h3>

                <div class="text-gray-400 fw-bold fs-6 mx-2">
                    Manage different locations of your business
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-3 align-self-center">
                <span id="biz-setup-number">3</span>
            </div>
            <div class="col-8 my-4">
                <h3 class="fw-bolder d-flex align-items-center text-dark mx-2">
                    User Setup
                    <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        ngbTooltip="Billing is issued based on your selected account type"
                    ></i>
                </h3>

                <div class="text-gray-400 fw-bold fs-6 mx-2">
                    Manage different users of your business
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-3 align-self-center">
                <span id="biz-setup-number">4</span>
            </div>
            <div class="col-8 my-4">
                <h3 class="fw-bolder d-flex align-items-center text-dark mx-2">
                    Configuration
                    <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        ngbTooltip="Billing is issued based on your selected account type"
                    ></i>
                </h3>

                <div class="text-gray-400 fw-bold fs-6 mx-2">
                    Set some basic configurations according to your business
                </div>
            </div>
        </div> -->
    <!-- </div> -->

    <div class="conn-card col" style="margin-right:30px;">
        <!-- <app-general-information *ngIf="activeTab == 'general-info-1'"></app-general-information> -->
        <!-- <app-location-information *ngIf="activeTab == 'location-setup'"></app-location-information> -->
        <!-- <app-user-information *ngIf="activeTab == 'user-setup'"></app-user-information> -->
        <app-configuration-information ></app-configuration-information>
        <!-- <app-final-step *ngIf="activeTab == 'final-step'"></app-final-step> -->


        <div class="terms-consent-field flex align-items-start mx-2">
            <p-checkbox
                [binary]="true"
                [(ngModel)]="termsAccepted"
                inputId="businessSetupTerms"
            ></p-checkbox>
            <label for="businessSetupTerms">
                I agree to the <a href="https://lincsell.com/terms-of-service/" target="_blank" rel="noopener">Terms &amp; Conditions</a> and <a href="https://lincsell.com/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a>, including prohibited use, restricted products/services, and policy violations.
            </label>
        </div>

        <div class="flex flex-nowrap card-container mb-12 justify-content-end" >
            <!-- <div class="flex align-items-center border-round mx-2" *ngIf="showBackButton">
                <button pButton type="button" class="light-button" label="Back" icon="pi pi-arrow-left"
                    (click)="back()" iconPos="left"
                    [style]="{
                        'margin-top': '30px',
                        'min-width': '100%',
                        width: '150px',
                        height: '45px'
                    }"></button>
            </div> -->
            <div class="flex align-items-center border-round mx-2">
                <button pButton type="button" [label]="'Finish'"
                     [disabled]="!termsAccepted"
                     (click)="saveFn()"  [style]="{
                        'margin-top': '30px',
                        'min-width': '100%',
                        width: '200px',
                        height: '45px'
                    }" ></button>
            </div>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="isTermsDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '640px' }"
    [breakpoints]="{ '960px': 'calc(100vw - 32px)' }"
    styleClass="business-setup-terms-dialog"
    header="Business Setup Terms &amp; Conditions"
>
    <div class="terms-dialog-body">
        <h3>1. Prohibited Use</h3>
        <p>
            Your business account must not be used to sell, promote, or distribute illegal goods or services,
            engage in fraudulent activity, infringe on intellectual property rights, distribute malware, or
            otherwise violate applicable laws and regulations.
        </p>
        <h3>2. Restricted Products/Services</h3>
        <p>
            Certain product and service categories are restricted or require additional approval, including
            (without limitation) weapons and ammunition, controlled substances, counterfeit goods, adult
            content, tobacco and vaping products, gambling services, and financial or investment products.
            Contact support before listing items in a restricted category.
        </p>
        <h3>3. Policy Violations</h3>
        <p>
            Accounts found in violation of these terms may be suspended or terminated without notice.
            Repeated or severe violations may also result in the loss of access to LincSell services.
            You are responsible for ensuring your business and its listings remain compliant at all times.
        </p>
    </div>
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="Close"
            (click)="closeTermsDialog()"
        ></button>
    </ng-template>
</p-dialog>
